import { render, staticRenderFns } from "./DestroyProfileInventory.vue?vue&type=template&id=f714cc2a&"
import script from "./DestroyProfileInventory.vue?vue&type=script&lang=js&"
export * from "./DestroyProfileInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports